module.exports = "<template>\n    <div>\n        <vbl-button @click=\"showLoading\">加载数据</vbl-button>\n    </div>\n</template>\n\n<script>\n    export default {\n        methods: {\n            showLoading() {\n                var loading = this.$loading.open();\n                setTimeout(() => {\n                    loading.destroy();\n                }, 200000);\n            }\n        }\n    }\n</script>"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./src/vblLoading/example/vblLoadingExample.vue
// module id = 170
// module chunks = 0